import { Switch, SwitchProps } from '@mui/material';
import { FC, forwardRef } from 'react';
import { styled } from '@/theme/index';

const Styled = styled(Switch)(({ theme }) => ({
  padding: theme.spacing(1),
  width: 'unset',
  height: 'unset',
  justifyContent: 'center',
  alignItems: 'center',
  '.MuiButtonBase-root': {
    left: 'unset',
    top: 'unset',
    transform: 'translateX(-15px)',
    transition: 'transform .25s',
    '&.Mui-checked': {
      transform: 'translateX(15px)',
      transition: 'transform .25s',
    },
  },
  '.MuiSwitch-track': {
    width: 60,
    height: 30,
    borderRadius: 30,
    padding: '0px 3px 0px 5px',
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 20,
      height: 12,
      fontSize: '0.75rem',
      color: 'white',
      lineHeight: 1,
    },
    '&:after': {
      content: '"OFF"',
      right: theme.spacing(2),
    },
  },
  '.MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 24,
    height: 24,
    backgroundColor: 'white',
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    opacity: 1,
    '&:before': {
      content: '"ON"',
    },
    '&:after': {
      content: '""',
    },
  },
}));

export const StyledSwitch: FC<SwitchProps> = forwardRef(
  (props: SwitchProps, ref) => {
    return <Styled {...props} ref={ref} />;
  }
);
